import { useTranslation } from 'react-i18next';
import { Calendar } from 'lucide-react';

/**
 * Kalendarz — strona-placeholder (decyzja Eugenii 2026-09-17). Ikona kalendarza jest wpięta
 * w paskach menu (pasek obszarów + mapa) oraz w kolumnie „Konto"; właściwy kalendarz z danymi
 * to osobny, większy temat. Do tego czasu trasa `/calendar` renderuje zajawkę „wkrótce",
 * żeby ikona działała i nie prowadziła do 404.
 */
export function CalendarPage() {
  const { t } = useTranslation();
  return (
    <main className="flex h-full min-h-0 flex-col bg-bg-secondary" data-testid="calendar-page">
      <header className="shrink-0 px-6 pb-5 pt-6">
        <h1 className="text-2xl font-bold text-text-primary">{t('tenant.calendar.title')}</h1>
      </header>
      <div className="flex flex-1 flex-col items-center justify-center gap-3 px-6 pb-16 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-bg-tertiary text-text-muted">
          <Calendar className="h-7 w-7" aria-hidden="true" />
        </span>
        <p className="text-sm text-text-secondary">{t('tenant.calendar.soon')}</p>
      </div>
    </main>
  );
}
